import { STOCK_SET_CURRENT, STOCK_SET_LIST } from './actionTypes';
import { stockApi } from 'helpers/api/stock';

export const Stock = {
  setStock: (stock) => (dispatch) => {
    dispatch(Stock.setCurrentAction(stock));
  },

  getStockList: (stockID) => async (dispatch, getState) => {
    const defaultStockID = stockID ? stockID : getState().auth.userData.defaultStockID;

    dispatch(Stock.setListAction(null));

    return stockApi
      .getList()
      .then(({ data } = {}) => {
        dispatch(Stock.setListAction(data));
        const stock = data.find((stock) => stock.stockID1C === defaultStockID);

        if (data.length > 0) {
          dispatch(Stock.setStock(stock || data[0]));
        }
      })
      .catch(() => {
        dispatch(Stock.setListAction([]));
      });
  },

  pingStockList: () => async (dispatch) => {
    return stockApi.getList().then(({ data } = {}) => {
      if (Array.isArray(data)) {
        dispatch(Stock.setListAction(data));
      }
    });
  },

  setCurrentAction: (payload) => ({
    type: STOCK_SET_CURRENT,
    payload,
  }),

  setListAction: (payload) => ({
    type: STOCK_SET_LIST,
    payload,
  }),
};
